import {
  IStackStyles,
  mergeStyles,
  Text,
  Stack,
  HoverCard,
  IPlainCardProps,
  HoverCardType,
} from "@fluentui/react";
import { FC, useState } from "react";
import { Document, UserModel } from "../../../models";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { useTranslation } from "react-i18next";
import { FormModal } from "../../modals/Modal";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import {
  createNewVersion,
  getDocumentversions,
} from "../../../modules/redux/Documents/document";
import { TextForPageHeaders } from "../../Text";
import Loader from "../../Loader";
import { VersionMembersModal } from "../../modals/VersionMembersModal";
import { colorPallete } from "../../../assets/color";
import { EmailNotesHoverCard } from "../HoverCard";
import { Thumbnails } from "../../Thumbnails";
import LockIcon from "../../../assets/Icons/svg/lockIcon";
import EditIcon from "../../../assets/Icons/svg/editIcon";
import DocumentIcon from "../../../assets/Icons/svg/documentIcon";
import RedLineDocumentIcon from "../../../assets/Icons/svg/redLineDocument";
import OpenFile from "../../../navigation/NoobOrPro";
import {
  getFormattedDateTime,
  getFullName,
  getSplitDocumentName,
} from "../../../utils";
import TrashIcon from "../../../assets/Icons/svg/trashIcon";
import Attachments from "../../../assets/Icons/svg/attachments";
import PdfIconWithTooltip from "./PdfIconWithTooltip";

import "./index.css";
import PdfIcon from "../../../assets/Icons/svg/pdfIcon";
import ReceivedIcon from "../../../assets/Icons/svg/receivedIcon";
import SendIcon from "../../../assets/Icons/svg/sendIcon";

const styles = {
  documentDivStyle: {
    height: "16rem",
    minWidth: "13rem",
    width: "13rem",
    margin: 3,
    marginRight: 6,
    zIndex: 1,
    position: "absolute",
  },
  notesDivStyle: {
    height: "10rem",
    minWidth: "13rem",
    width: "13rem",
    backgroundColor: "#f3f2f1",
    borderRadius: "0.4rem",
    border: "2px light grey",
    margin: 3,
    marginRight: 6,
    zIndex: 2,
  },
  ImageStyle: {
    borderTopLeftRadius: "0.4rem",
    borderTopRightRadius: "0.4rem",
  },
  IconStyle: {
    marginBottom: "13%",
    paddingRight: "2%",
    overflow: "visible",
  },
  FileNameStackStyle: {
    height: "22%",
    backgroundColor: "",
    width: "100%",
  },
  notesStyle: {
    backgroundColor: "",
    height: "70%",
  },
  bottomContainer: {
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    bottom: 0,
  },
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "",
  },
  docText: { fontSize: "14px", paddingBottom: "4%", fontFamily: "Poppins" },
  modalContainer: { background: "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)" },
  iconContainer: {
    backgroundColor: "yellow",
    alignItems: "center",
    width: "12%",
    height: "100%",
    gap: "3%",
  },
  redLinedIcon: {
    backgroundColor: "",
    alignItems: "center",
    width: "12%",
    height: "90%",
    justifyContent: "center",
  },
  receivedIcon: {
    backgroundColor: "",
    marginTop: "12%",
    height: "100%",
    width: "100%",
    alignItems: "center",
  },
  dateAndTime: {
    fontSize: "10px",
    lineHeight: "16px",
    color: colorPallete.black,
    fontWeight: 600,
    paddingLeft: "10px",
    fontFamily: "Poppins",
    fontStyle: "normal",
  },
  emailNotes: {
    fontSize: "12px",
    lineHeight: "18px",
    color: colorPallete.black,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    fontFamily: "Poppins",
  },
  Info: {
    fontSize: "12px",
    lineHeight: "18px",
    color: colorPallete.black,
    fontWeight: 600,
    fontFamily: "Poppins",
  },
  myDraft: {
    fontSize: "12px",
    lineHeight: "18px",
    color: colorPallete.black,
    fontWeight: 600,
    marginTop: "18px",
    marginBottom: "8px",
    fontFamily: "Poppins",
    height: "38%",
  },
  headers: {
    color: colorPallete.grey,
    fontSize: "11px",
    lineHeight: "18px",
    fontFamily: "Poppins",
  },
  versionName: {
    fontSize: "12px",
    color: colorPallete.black,
    lineHeight: "18px",
    paddingLeft: "10px",
    fontFamily: "Poppins",
    fontWeight: "600",
  },
  dateAndIconStack: {
    width: "91%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fileTypeText: {
    color: colorPallete.grey,
    fontSize: "10px",
    lineHeight: "18px",
    paddingLeft: "10px",
    fontFamily: "Poppins",
  },
  fileTypeTextStack: {
    bottom: "12px",
    width: "100%",
    height: "20%",
    alignSelf: "center",
    left: 5,
  },
  DocumentNameStack: {
    width: "100%",
    top: "50%",
  },
  InfoStack: {
    backgroundColor: "",
    width: "100%",
    gap: "10%",
    alignItems: "flex-start",
  },
  DocCover: {
    height: "250px",
    minWidth: "200px",
    width: "200px",
    background: "rgba(223, 230, 239, 0.55)",
    boxShadow: "0px 4px 6px rgb(0 0 0 / 25%)",
    padding: "15px",
  },
  VersionCard: {
    height: "300px",
    minWidth: "220px",
    width: "220px",
    borderRadius: "1px",
    border: "1px solid #DFE6EF",
    background: "white",
    boxShadow: "4px 4px 4px 0 rgba(0, 0, 0, 0.24)",
    cursor: "pointer",
    justifySelf: "center",
  },
  recepientList: {
    marginTop: "2%",
    display: "inline-block",
    height: "100%",
    width: "90%",
  },
  RecepientHoverCard: {
    fontSize: "12px",
    borderRadius: "1rem",
    minWidth: "1px",
    maxWidth: "fit-content",
    color: "rgb(6 42 108)",
    cursor: "pointer",
    lineHeight: "18px",
  },
  CreateVersionButtonsStack: {
    width: "94%",
    marginLeft: "3%",
    justifyContent: "space-around",
    bottom: "0px",
    height: "40%",
    alignItems: "center",
    position: "relative",
    backgroundColor: "white",
    borderRadius: "0px 0px 8px 8px",
    top: "2px",
    padding: "10px 0",
    marginBottom: "14px"
  },
  CreateVersionText: {
    width: "94%",
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 4% 0%",
    marginTop: "1%",
    backgroundColor: "white",
    borderRadius: "8px 8px 0 0",
  },
};

const uploadModal = mergeStyles({
  display: "flex",
  justifyContent: "flex-start",
  width: "98%",
  minHeight: "8rem",
  alignItems: "center",
  padding: "1%",
});

const success = mergeStyles({
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "30px",
});

const loading = mergeStyles({
  margin: "2%",
  paddingTop: "30px",
});

const stackStyles: IStackStyles = {
  root: {
    width: "100%",
    height: "100%",
    position: "absolute",
    opacity: 0.4,
  },
};

type Props = {
  version: Document;
  members?: UserModel[];
  length?: number;
  delete?: boolean;
  showModal?: any;
  setDeleteversion?: any;
  projectName?: string;
};

interface Props1 {
  recipients: UserModel[] | undefined;
  fileType: string | undefined;
}

const RenderPerson: FC<Props1> = (props) => {
  const { recipients } = props;
  const remainingCount: any = recipients && recipients?.length - 1;
  if (props.fileType === "received" && recipients?.length === 0) {
    return <Text style={styles.Info}>Me</Text>;
  } else {
    return recipients && recipients.length ? (
      <div style={{ ...styles.recepientList, wordWrap: "break-word" }}>
        <HorizontalStack style={{ width: "130%", flexWrap: "wrap" }}>
          {props.fileType === "received" ? (
            <Text style={styles.Info}>Me</Text>
          ) : (
            <Text style={styles.Info}>{getFullName(recipients[0])}</Text>
          )}

          {props.fileType === "received" ? (
            <RecipientHoverCard recipients={recipients} />
          ) : (
            remainingCount > 0 && (
              <RecipientHoverCard recipients={recipients.slice(1)} />
            )
          )}
        </HorizontalStack>
      </div>
    ) : (
      <></>
    );
  }
};

const RecipientHoverCard: React.FC<{ recipients: UserModel[] }> = ({
  recipients,
}) => {
  const { t } = useTranslation();
  const plainCardProps: IPlainCardProps = {
    onRenderPlainCard: () => (
      <div style={{ padding: "10px", backgroundColor: colorPallete.white }}>
        <ul style={{ listStyleType: "none" }}>
          {recipients.map((recipient, index) => (
            <li key={getFullName(recipient)}>{getFullName(recipient)}</li>
          ))}
        </ul>
      </div>
    ),
    directionalHint: 1,
  };
  return (
    <HoverCard type={HoverCardType.plain} plainCardProps={plainCardProps}>
      <div style={styles.RecepientHoverCard}>
        ,&nbsp;{`+${recipients.length} `}
        {recipients.length === 1 ? t("other") : t("others")}
      </div>
    </HoverCard>
  );
};

export const DocumentVersionInCard: FC<Props> = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [modal, setModal] = useState<boolean>(false);
  const [upload, setUpload] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [refreshHover, setRefresHover] = useState<boolean>(false);
  const [hoverNewVersion, setHoverNewVersion] = useState(false);
  const [hoverReadOnly, setHoverReadOnly] = useState(false);
  const [docToolTip, setDocToolTip] = useState("none");
  const [hoverCard, setHoverCard] = useState(false);
  const replyAll =
    props.version &&
    props?.version?.shareDetails &&
    Array.isArray(props?.version?.shareDetails?.replyAll)
      ? props?.version?.shareDetails?.replyAll
      : [];
  const reply =
    props.version &&
    props?.version?.shareDetails &&
    props?.version?.shareDetails?.reply;
  const receivedList = replyAll?.filter(
    (user) => user?.userId !== reply?.userId
  );
  const getSentVersionAccessState = useAppSelector((state) => {
    return state.getSentVersionAccess;
  });

  const [membersModal, setMembersModal] = useState(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const isDocFile =
    props.version?.metadata?.fileType === "docx" ||
    props.version?.metadata?.fileType === "doc";

  const openFile = (
    wordLocalUrl: string | undefined,
    wordWebUrl: string | undefined
    // fileExtension: string | undefined
  ) => {
    hideDocModal();
    OpenFile(wordLocalUrl, wordWebUrl);
  };

  function showMembersModal() {
    setMembersModal(true);
  }

  function hideMembersModal() {
    setMembersModal(false);
  }

  function showDocModal() {
    setModalOpen(true);
  }

  function hideDocModal() {
    setModalOpen(false);
  }
  function handleCreateNewVersion() {
    if (props.version?.id) {
      setModal(true);
      dispatch(createNewVersion(props.version?.id)).then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          setUpload(true);
          setMessage("create_new_version_success");
          setTimeout(() => {
            disable();
            props.version.metadata.fileType === "pdf"
              ? window.open(props.version.metadata.documentLink)
              : openFile(
                  props.version.metadata.documentLink,
                  props.version.metadata.documentWebLink
                );
          }, 2000);
        } else if (res.meta.requestStatus === "rejected") {
          setMessage("something_went_wrong");
        }
        setTimeout(() => {
          dispatch(
            getDocumentversions({
              rootDocumentId: props.version.rootDocumentId,
              limit: 6,
              offset: 0,
            })
          );
          disable();
        }, 4000);
      });
    }
  }

  const Modal = (
    <FormModal
      isModalOpen={modalOpen}
      showModal={showDocModal}
      hideModal={hideDocModal}
      cancelButton={true}
      width="500px"
      height="auto"
      TitleBackgroundColor="linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)"
      HeaderPadding="6px 10px"
    >
      {modal ? (
        <Stack className={uploadModal}>
          {!upload ? (
            <>
              <Stack className={loading}>
                <Loader />
              </Stack>
              <TextForPageHeaders>
                {t("creating_new_version")}
              </TextForPageHeaders>
            </>
          ) : (
            <VerticalStack className={success}>
              <img
                src={require("../../../assets/tick.png")}
                height="50px"
                width="50px"
                alt="Error"
              />
              <TextForPageHeaders>{t(message)}</TextForPageHeaders>
            </VerticalStack>
          )}
        </Stack>
      ) : (
        <Stack className={mergeStyles(styles.modalContainer)}>
          <Stack style={styles.CreateVersionText}>
            <Text className={mergeStyles(styles.docText)}>
              {t("open_document_version")}
            </Text>
          </Stack>
          <HorizontalStack
            style={{
              ...styles.CreateVersionButtonsStack,
              position: "relative",
            }}
          >
            <Stack
              onClick={() => {
                handleCreateNewVersion();
              }}
              style={{
                backgroundColor: hoverNewVersion ? colorPallete.white : "#E8ECF4",
                color: colorPallete.black1,
                borderRadius: "4px",
                height: "40px",
                width: "180px",
                fontFamily: "Poppins",
                fontWeight: "500",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
                border: hoverNewVersion ? `1px solid ${colorPallete.black1}` : "1px solid #E8ECF4",
              }}
              onMouseEnter={() => setHoverNewVersion(true)}
              onMouseLeave={() => setHoverNewVersion(false)}
            >
              {t("create_new_version")}
            </Stack>
            <Stack
              onClick={() => {
                props.version.metadata.fileType === "pdf"
                  ? window.open(props.version.metadata.documentLink)
                  : openFile(
                      props.version.metadata.documentLink,
                      props.version.metadata.documentWebLink
                    );
              }}
              style={{
                backgroundColor: hoverReadOnly ? colorPallete.white : "#E8ECF4",
                color: colorPallete.black1,
                borderRadius: "4px",
                height: "40px",
                width: "180px",
                fontFamily: "Poppins",
                fontWeight: "500",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
                border: hoverReadOnly ? `1px solid ${colorPallete.black1}` : "1px solid #E8ECF4",
              }}
              onMouseEnter={() => setHoverReadOnly(true)}
              onMouseLeave={() => setHoverReadOnly(false)}
            >
              {t("open_read_only")}
            </Stack>
          </HorizontalStack>
        </Stack>
      )}
    </FormModal>
  );

  const disable = () => {
    setMessage("");
    setModal(false);
    setUpload(false);
    hideDocModal();
  };

  const getFileTypeText = (fileType: string | undefined) => {
    if (fileType === "draft") {
      return t("last_saved_on");
    } else if (fileType === "sent") {
      return t("sent_on");
    } else {
      return t("received_on");
    }
  };

  const getFileIcon = (props: Document) => {
    if (
      props.fileType === "draft" &&
      props.metadata.isRedlined === true
    ) {
      return (
        <div>
          <RedLineDocumentIcon />
        </div>
      );
    } else if (props.metadata.fileType === "pdf") {
      return (
        <div>
          <PdfIconWithTooltip documentLink={props.metadata.documentLink} props={props} />
        </div>
      );
    }
  };

  return (
    <div style={{ ...styles.VersionCard, position: "relative", 
      background:
      props.version.metadata.fileType === "pdf"
        ? "rgba(168, 44, 12, 0.10)"
        : "white",
        transform: hoverCard ? "scale(1.05) translateZ(0px)" : "scale(1) translateZ(0px)",
        transition: "transform 0.2s ease-in-out",
        }}
        onMouseEnter={() => {
          setHoverCard(true);
        }}
        onMouseLeave={() => {
          setHoverCard(false);
        }}
        onClick={() => {
          if (
            props.version.fileType === "sent" &&
            !props.setDeleteversion(props.version) &&
            !refreshHover
          ) {
            props.version.metadata.fileType === "pdf"
              ? window.open(props.version.metadata.documentLink)
              : showDocModal();
          } else if (!props.setDeleteversion(props.version)  && !refreshHover) {
            props.version.metadata.fileType === "pdf"
              ? window.open(props.version.metadata.documentLink)
              : openFile(
                  props.version.metadata.documentLink,
                  props.version.metadata.documentWebLink
                );
          }
        }}
        >
      <VerticalStack styles={stackStyles}>
        <Thumbnails
          driveItemId={props.version.metadata.driveItemId}
          height="100%"
          width="fit-content"
        />
      </VerticalStack>
      <div style={{ ...styles.DocCover, position: "absolute" }}>
        {Modal}
        <VerticalStack
          className={mergeStyles(styles.container)}
          data-testid="document-container"
        >
          <HorizontalStack style={{ width: "100%", height: "75%" }}>
            <VerticalStack style={{ height: "100%", gap: "10%", width: "88%" }}>
              {props.version.fileType !== "draft" ? (
                <VerticalStack style={styles.FileNameStackStyle}>
                  <Text style={styles.headers}>{t("from")}:</Text>
                  {props.version.fileType === "sent" ? (
                    <Text style={styles.Info}>{t("me")}</Text>
                  ) : props.version.fileType === "received" ? (
                    <Text style={styles.Info}>
                      {(reply && getFullName(reply)) ?? ""}
                    </Text>
                  ) : null}
                </VerticalStack>
              ) : (
                <>
                  <Text style={styles.myDraft}>{t("my_draft")}</Text>
                </>
              )}
              {props.version.fileType !== "draft" ? (
                <VerticalStack style={styles.InfoStack}>
                  <VerticalStack style={{ width: "100%" }}>
                    <Text style={styles.headers}>{t("to")}:</Text>
                    {replyAll?.length === 0 &&
                    props.version.fileType === "sent" ? (
                      <VerticalStack
                        style={{
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <Text style={{ ...styles.Info, color: "#717070" }}>
                          {t("sharing_progress")}
                        </Text>
                        <Text
                          style={{
                            ...styles.Info,
                            color: colorPallete.btBlue,
                            textDecoration: "underline",
                            cursor: "pointer",
                            zIndex: 10,
                          }}
                          onMouseEnter={() => {
                            setRefresHover(true);
                          }}
                          onMouseLeave={() => {
                            setRefresHover(false);
                          }}
                          onClick={() => {
                            window.location.reload();
                          }}
                        >
                          {t("click_to_refresh")}
                        </Text>
                      </VerticalStack>
                    ) : null}
                    {props.version.fileType === "sent" &&
                    replyAll?.length !== 0 ? (
                      <Text style={styles.Info}>
                        <RenderPerson
                          recipients={replyAll}
                          fileType={props.version.fileType}
                        />
                      </Text>
                    ) : null}
                    {props.version.fileType === "received" && (
                      <Text style={styles.Info}>
                        <RenderPerson
                          recipients={receivedList}
                          fileType={props.version.fileType}
                        />
                      </Text>
                    )}
                  </VerticalStack>

                  {props.version.shareDetails?.subject &&
                    props.version.shareDetails?.subject !== "" && (
                      <VerticalStack
                        style={{
                          ...styles.notesStyle,
                          width: "88%",
                          backgroundColor: "",
                          marginTop: "5%",
                        }}
                        title={props.version.shareDetails?.subject ?? ""}
                      >
                        <Text style={styles.headers}>{t("Subject")}:</Text>
                        <Text
                          className={mergeStyles(styles.emailNotes)}
                          style={{
                            WebkitLineClamp: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontWeight: 600,
                          }}
                        >
                          {props.version.shareDetails?.subject ?? ""}
                        </Text>
                      </VerticalStack>
                    )}
                </VerticalStack>
              ) : (
                <VerticalStack
                  style={{ ...styles.InfoStack, justifyContent: "flex-end" }}
                >
                  <VerticalStack style={{ ...styles.DocumentNameStack }}>
                    <Text style={styles.headers}>Document :</Text>
                    <Text
                      style={{
                        ...styles.Info,
                        width: "calc(99% - 18px)",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        textOverflow: "ellipsis",
                        WebkitLineClamp: 2,
                        overflow: "hidden",
                      }}
                      title={props.version.rootDocumentName}
                    >
                      {getSplitDocumentName(props.version.rootDocumentName) ??
                        ""}
                    </Text>
                  </VerticalStack>
                </VerticalStack>
              )}
            </VerticalStack>
            <VerticalStack
              style={{
                width: "auto",
                height: "40%",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "4%",
                position: "absolute",
                right: "5px",
                top: "5px",
              }}
            >
           {( props.version.fileType === "received" || props.version.fileType === "sent") && (
                  <div
                    data-testid="docx-icon-wrapper"
                    style={{
                      // padding: "8px",
                      // height: "40px",
                      display: "inline-block",
                      borderRadius: "4px",
                    }}
                  >
                    <EmailNotesHoverCard
                      notes={props?.version?.shareDetails?.emailNotes ?? ""}
                      fileType={props.version.fileType}
                      sharedBy={props.version.shareDetails?.reply}
                      sharedTo={props.version.shareDetails?.replyAll}
                      receivedList={props.version.shareDetails?.replyAll?.filter(
                        (user) => user?.userId !== props.version.shareDetails?.reply?.userId
                      )}
                      projectName={props.projectName ?? props.version.projectName}
                      subject={props.version.shareDetails?.subject}
                      metadataFileType={props.version.metadata.fileType}
                    />
                  </div>
                  )}
              {props.version.fileType === "draft" &&
                props.version.metadata.fileType !== "pdf" &&
                props.version.metadata.isRedlined === false && (
                  <div
                    style={{
                      padding: "8px",
                      height: "40px",
                      display: "inline-block",
                      borderRadius: "4px",
                    }}
                  >
                    <DocumentIcon />
                  </div>
                )}
                {getFileIcon(props.version)}
              {props.version.attachment?.fileType === "pdf" && (
                <PdfIconWithTooltip documentLink={props.version.attachment?.documentLink} props={props.version}>
                  <span style={{ position: "absolute", top: "1px", right: "25px" }}>
                    <Attachments/>
                  </span>
                </PdfIconWithTooltip>
              )}
            </VerticalStack>
          </HorizontalStack>
        </VerticalStack>
        <HorizontalStack
          style={{ ...styles.fileTypeTextStack, position: "absolute" }}
          horizontalAlign="space-between"
          verticalAlign="end"
        >
          <VerticalStack style={{ width: "100%" }}>
            {props.version.lastUpdatedDate !== null ? (
              <HorizontalStack
                style={{ width: "90%", justifyContent: "space-between" }}
              >
                <Text style={styles.fileTypeText}>
                  {getFileTypeText(props.version.fileType)}
                </Text>
                <Text style={styles.versionName}>
                  V{props.version.version}
                </Text>
              </HorizontalStack>
            ) : null}
            <HorizontalStack style={styles.dateAndIconStack}>
              {props.version.lastUpdatedDate !== null ? (
                <VerticalStack>
                  <Text style={styles.dateAndTime}>
                    {getFormattedDateTime(props.version.lastUpdatedDate!)[0]}
                  </Text>
                  <Text style={styles.dateAndTime}>
                    {getFormattedDateTime(props.version.lastUpdatedDate!)[1]}
                  </Text>
                </VerticalStack>
              ) : null}
              <HorizontalStack
                style={{
                  width: "100%",
                    // props.length === 1
                    //   ? ""
                    //   : props.version.fileType !== "sent"
                    //   ? "25%"
                    //   : "",
                  justifyContent: "end",
                  backgroundColor: "",
                  left: "5px",
                  position: "relative",
                  gap: "3px",
                }}
              >
                {props.version.fileType === "sent" ? (
                  <HorizontalStack style={{ alignItems: "center" }}>
                    <img
                      alt=""
                      src={require("../../../assets/Icons/ViewDoc.png")}
                      style={{ display: docToolTip,
                        position: "absolute",
                        height: "40px",
                        right: "25px",
                        zIndex: 2,
                        top: "0px"
                      }}
                    />
                    <div
                      onClick={() => {
                        props.version.metadata.fileType === "pdf"
                          ? window.open(props.version.metadata.documentLink)
                          : showDocModal();
                      }}
                      onMouseEnter={() => {
                        setDocToolTip("flex");
                      }}
                      onMouseLeave={() => {
                        setDocToolTip("none");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="lockIconContainer iconHover">
                        <LockIcon />
                      </div>
                    </div>
                  </HorizontalStack>
                ) : (
                  <HorizontalStack>
                    <img
                      alt=""
                      src={require("../../../assets/Icons/EditDoc.png")}
                      style={{
                        display: docToolTip,
                        position: "absolute",
                        height: "40px",
                        right: props.length !== 1 ? "55px" : "38px",
                        zIndex: 2,
                        top: "0px",
                      }}
                    />
                    {props.version.metadata.fileType !== "pdf" && (
                      <div
                        id="edit"
                        style={{ cursor: "pointer", position: "relative" }}
                        onClick={() => {
                          if (!props.setDeleteversion(props.version)) {
                            openFile(
                              props.version.metadata.documentLink,
                              props.version.metadata.documentWebLink
                            );
                          }
                        }}
                        onMouseEnter={() => {
                          setDocToolTip("flex");
                        }}
                        onMouseLeave={() => {
                          setDocToolTip("none");
                        }}
                      >
                        <div className="editIconContainer iconHover">
                          <EditIcon />
                        </div>
                      </div>
                    )}
                  </HorizontalStack>
                )}
                {props.version.fileType !== "sent" &&
                (props.length !== 1 ||
                  props.version.metadata.fileType === "pdf") ? (
                  <Stack
                    style={{ cursor: "pointer" }}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (!props.setDeleteversion(props.version)) {
                        props.setDeleteversion(props.version);
                        props.showModal();
                      }
                    }}
                  >
                    <div className="trashIconContainer iconHover">
                      <TrashIcon />
                    </div>
                  </Stack>
                ) : null}
              </HorizontalStack>
            </HorizontalStack>
          </VerticalStack>
        </HorizontalStack>
      </div>
      
      {props.version.metadata.fileType === "pdf" && (
        <div style={{ position: "absolute", bottom: 0, right: 0, opacity: 0.5 }}>
          <PdfIcon />
        </div>
      )}
      {(props.version.metadata.fileType === "docx" || props.version.metadata.fileType === "doc") && (
        <div className="documentIcon" style={{ position: "absolute", bottom: 0, right: 0, opacity: 0.5 }}>
          <DocumentIcon />
        </div>
      )} 
      <VersionMembersModal
        isLoading={getSentVersionAccessState.isLoading}
        isModalOpen={membersModal}
        showModal={showMembersModal}
        hideModal={hideMembersModal}
        members={getSentVersionAccessState.data}
      />
    </div>
  );
};
